import { render, staticRenderFns } from "./bread-crumbs.vue?vue&type=template&id=cc51d766&scoped=true&"
import script from "./bread-crumbs.vue?vue&type=script&lang=js&"
export * from "./bread-crumbs.vue?vue&type=script&lang=js&"
import style0 from "./bread-crumbs.vue?vue&type=style&index=0&id=cc51d766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc51d766",
  null
  
)

export default component.exports